import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GreenHouseMapEffects } from 'app/state/green-house-map/green-house-map.effects';

import { greenHouseMapFeature } from './green-house-map.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(greenHouseMapFeature), EffectsModule.forFeature([GreenHouseMapEffects])],
})
export class GreenHouseMapStateModule {}
